import * as React from 'react';

import classNames from 'classnames';
import type { LocationDescriptorObject } from 'history';

import { simplifyQueryValue } from 'js/lib/queryUtils';

import { TeamsContext } from 'bundles/teams-v2/components/TeamsContainer';
import TeamsPurchaseCheckoutSummary from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummary';
import TeamsPurchaseCheckoutSummaryMobile from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummaryMobile';

import 'css!./__styles__/TeamsPurchaseSummary';

export type Props = {
  query: LocationDescriptorObject['query'];
  mobileOnly?: boolean;
  path?: string;
  className?: string;
};

export const TeamsPurchaseSummary: React.FC<Props> = (props) => {
  const { query, mobileOnly, path, className } = props;

  const { learnerCount, billingType, productPrice, promotion, isPromotionEligible } = React.useContext(TeamsContext);

  let loading = false;

  if (!productPrice) {
    loading = true;
  }

  const discountPercentage = isPromotionEligible ? productPrice?.discountPercent || promotion?.discountPercent : 0;
  const discountAmount = productPrice?.actualLocalDiscountedAmount;
  // TODO: I believe this is incorrect but will work until i18n is added
  const originalPrice = productPrice?.rawLocalAmountTotal;
  const discountedPrice = productPrice?.actualLocalAmountTotal;

  const organizationName = query && simplifyQueryValue(query.organizationName);

  // TODO: These values are probably inappropriate
  const total = productPrice?.actualLocalAmountTotal;
  const todaysTotal = productPrice?.actualLocalAmountDueToday;

  const currencyCode = productPrice?.currencyCode;
  const unitPrice = productPrice?.unitPrice;

  return (
    <div
      className={classNames(
        'rc-TeamsPurchaseSummary vertical-box align-items-vertical-center',
        'rc-TeamsPurchaseSummary--redesign',
        className,
        { mobileOnly },
        { desktopOnly: !mobileOnly }
      )}
    >
      {mobileOnly && (
        <TeamsPurchaseCheckoutSummaryMobile
          total={total}
          todaysTotal={todaysTotal}
          organizationName={organizationName}
          learnerCount={learnerCount}
          billingType={billingType}
          unitPrice={unitPrice}
          showEditLink={path === 'billing'}
          loading={loading}
          currency={currencyCode}
          discountPercentage={discountPercentage}
          discountAmount={discountAmount}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      )}
      {!mobileOnly && (
        <TeamsPurchaseCheckoutSummary
          total={total}
          todaysTotal={todaysTotal}
          organizationName={organizationName}
          learnerCount={learnerCount}
          billingType={billingType}
          unitPrice={unitPrice}
          showEditLink={path === 'billing'}
          loading={loading}
          currency={currencyCode}
          discountPercentage={discountPercentage}
          discountAmount={discountAmount}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      )}
    </div>
  );
};

export default TeamsPurchaseSummary;
